/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_TitleInputs */

const en_templates_title = /** @type {(inputs: Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification templates`)
};

const he_templates_title = /** @type {(inputs: Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תבניות התראה`)
};

/**
* | output |
* | --- |
* | "Notification templates" |
*
* @param {Templates_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_title = /** @type {((inputs?: Templates_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_title(inputs)
	return he_templates_title(inputs)
});